import React, { useCallback, useEffect, useState, useRef } from "react";

import { formatMoney } from "functions/formatDynamicData"; 

import PropTypes from "prop-types";
import clg from "functions/log";

const MultiRangeSlider = ({ min, max, value, onChange, containerClasses = "", col = "col-lg-6 col-12", sliderValPostfix, title, valFormat = null, step = null }) => {
  const [minVal, setMinVal] = useState(value.min);
  const [maxVal, setMaxVal] = useState(value.max);
  const minValRef = useRef(value.min);
  const maxValRef = useRef(value.max);
  const range = useRef(null);

  // Convert to percentage
  const getPercent = useCallback(
    (value) => Math.round(((value - min) / (max - min)) * 100),
    [min, max]
  );

  // Set width of the range to decrease from the left side
  useEffect(() => {
    const minPercent = getPercent(minVal);
    const maxPercent = getPercent(maxValRef.current);

    if (range.current) {
      range.current.style.left = `${minPercent}%`;
      range.current.style.width = `${maxPercent - minPercent}%`;
    }
  }, [minVal, getPercent]);

  // Set width of the range to decrease from the right side
  useEffect(() => {
    const minPercent = getPercent(minValRef.current);
    const maxPercent = getPercent(maxVal);

    if (range.current) {
      range.current.style.width = `${maxPercent - minPercent}%`;
    }
  }, [maxVal, getPercent]);

  // Get min and max values when their state changes
  useEffect(() => {
    //onChange({ min: minVal, max: maxVal });
  }, [minVal, maxVal, /* onChange */]);

  // Get min and max values when their state changes
  const handleCommit = () => {
    onChange({ min: minVal, max: maxVal });
  };

  const formatVal = ( val ) => {
    if( valFormat ) {

      let formatted;

      switch ( valFormat ) {
        case "money":
          return formatMoney( val );
      }

      return val;
    }

    if( !valFormat ) {
      return val;
    }
  }

  return (
    <div className={"p-0 multi-range-slider-container " + col + ( containerClasses.length ? " " : "" ) + containerClasses}>

        <div className="multi-range-slider-title">{ title }</div>

        <input
            type="range"
            min={min}
            max={max}
            value={minVal}
            step={ step ? step : "" }
            onChange={(event) => {
              const value = Math.min(Number(event.target.value), maxVal - 1);
              setMinVal(value);
              minValRef.current = value;
            }}
            onMouseUp={ () => handleCommit() }
            onTouchEnd={ () => handleCommit() }
            className="thumb thumb--left"
            style={{ zIndex: minVal > max - 100 && "5" }}
        />
        <input
            type="range"
            min={min}
            max={max}
            value={maxVal}
            step={ step ? step : "" }
            onChange={(event) => {
              const value = Math.max(Number(event.target.value), minVal + 1);
              setMaxVal(value);
              maxValRef.current = value;
            }}
            onMouseUp={ () => handleCommit() }
            onTouchEnd={ () => handleCommit() }
            className="thumb thumb--right"
        />

        <div className="slider">
            <div className="slider__track" />
            <div ref={range} className="slider__range" />
            <div className="slider__left-value">{ formatVal(minVal) }{ sliderValPostfix ?? sliderValPostfix }</div>
            <div className="slider__right-value">{ formatVal(maxVal) }{ sliderValPostfix ?? sliderValPostfix }</div>
        </div>

    </div>
  );
};

MultiRangeSlider.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
};

export default MultiRangeSlider;
